import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { IButton, ICategory, ILink, IWidgetSet } from "../../../gatsby-graphql"
import { Button, Heading } from "../../ui"
import { ButtonType } from "../../ui/button/button-elements"
import {
  Articles,
  Categories,
  CategoryLink,
  ContentWrapper,
  HeadingWrapper,
  LeftCol,
  RightCol,
  SectionWrapper,
} from "./articles-with-widgets-elements"
import ArticlesList from "../../components/articles-list"
import WidgetsSet from "../../components/widgets-set"
import { SectionProps } from "../section-loader"

interface ArticlesWithWidgetsProps extends SectionProps {
  data: {
    heading?: string
    articlesCount?: number
    categories?: ICategory[]
    widgetSet?: IWidgetSet
    moreButton?: IButton
  }
}

const ArticlesWithWidgets = ({ data, locale }: ArticlesWithWidgetsProps) => {
  const { t } = useTranslation()
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null)

  return (
    <SectionWrapper>
      <ContentWrapper>
        <LeftCol>
          <HeadingWrapper>
            <Heading.H4 textTransform="uppercase">{data.heading}</Heading.H4>
            {data.categories && data.categories.length > 0 && (
              <Categories>
                <CategoryLink
                  selected={selectedCategory === null}
                  onClick={() => setSelectedCategory(null)}
                >
                  {t("All")}
                </CategoryLink>
                {data.categories.map((category, index) => (
                  <CategoryLink
                    selected={selectedCategory === category.slug}
                    onClick={() => setSelectedCategory(category.slug as string)}
                    key={index}
                  >
                    {category.name}
                  </CategoryLink>
                ))}
              </Categories>
            )}
            <Button
              type={data.moreButton?.type as ButtonType}
              link={data.moreButton?.link as ILink}
              locale={locale}
            />
          </HeadingWrapper>
          <Articles>
            <ArticlesList
              params={{
                count: data.articlesCount,
                locale: locale,
                categorySlug: selectedCategory,
              }}
              basePath={`/${data.moreButton?.link?.locale}/${data.moreButton?.link?.slug}/`}
            />
          </Articles>
        </LeftCol>
        <RightCol>
          {data.widgetSet && <WidgetsSet data={data.widgetSet} />}
        </RightCol>
      </ContentWrapper>
    </SectionWrapper>
  )
}

export default ArticlesWithWidgets
